(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("d3"), require("dagre-d3"), require("xml2js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "d3", "dagre-d3", "xml2js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("d3"), require("dagre-d3"), require("xml2js")) : factory(root["react"], root["d3"], root["dagre-d3"], root["xml2js"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 